import { __assign, __extends } from "tslib";
import { Playback } from '@wix/soundhead-playback';
import * as React from 'react';
import { defaultPlayback, defaultPlayerProps } from '../../defaultSettings';
import { isEqual, noop } from '../../utils';
import PlayerEngine from '../PlayerEngine';
var SinglePlayer = /** @class */ (function (_super) {
    __extends(SinglePlayer, _super);
    function SinglePlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.playback = defaultPlayback;
        _this._setPlayerRef = function (instance) {
            _this.props.playerRef(instance);
            _this.player = instance;
        };
        return _this;
    }
    SinglePlayer.prototype.componentDidMount = function () {
        this.playback = new Playback();
        if (this.player) {
            this.player.injectPlayback(this.playback);
            this.player.bindAudioEvents();
            this.player.registerPlayer();
        }
    };
    SinglePlayer.prototype.componentWillUnmount = function () {
        this.playback.destroy();
        delete this.playback;
    };
    SinglePlayer.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        [
            ['loop', 'setLoop'],
            ['volume', 'setVolume'],
            ['playbackRate', 'setPlaybackRate'],
            ['muted', 'setMute'],
            ['autoplay', 'setAutoplay'],
        ].forEach(function (_a) {
            var _b;
            var prop = _a[0], method = _a[1];
            // @ts-ignore
            if (prevProps[prop] !== _this.props[prop]) {
                // @ts-ignore
                _this.player.saveAudioProps((_b = {}, _b[prop] = _this.props[prop], _b));
                // @ts-ignore
                _this.playback[method](_this.props[prop]);
            }
        });
        if (this.player && !isEqual(prevProps.playlist, this.props.playlist)) {
            this.playback.setPlaylist(this.props.playlist);
            this.player.updateTrack();
        }
    };
    SinglePlayer.prototype.render = function () {
        return React.createElement(PlayerEngine, __assign({}, this.props, { ref: this._setPlayerRef }));
    };
    SinglePlayer.displayName = 'SinglePlayer';
    SinglePlayer.defaultProps = __assign(__assign({}, defaultPlayerProps), { playerRef: noop });
    return SinglePlayer;
}(React.Component));
export default SinglePlayer;
//# sourceMappingURL=SinglePlayer.js.map